import { Stack, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import React from "react";
import IconButton from "@mui/material/IconButton";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useSortFilter } from "../SortFilterContext";

function ColumnInfo({
  text,
  borderLeft = 3,
  handleSortClick,
  sortedBy,
  ascendingSort,
  sort_key,
}) {

  return (
    <TableCell
      align="center"
      colSpan={1}
      sx={{
        p: 0,
        borderBottom: 3,
        bgcolor: "lightgray",
        borderLeft: borderLeft,
        pb:0.5
      }}
    >
      <Stack direction={"row"} justifyContent={"center"} spacing={1}>
        <Typography variant="body">{text}</Typography>
        <Tooltip title={`Sort By: ${text} Ascending`} arrow >

       
        <IconButton
          onClick={() => handleSortClick(sort_key, true)}
          sx={{
            border: 0,
            p: 0.25,
            bgcolor:
              ascendingSort && sortedBy === sort_key ? "secondary.main" : null,
            color: ascendingSort && sortedBy === sort_key ? "white" : null,
            borderColor: ascendingSort && sortedBy === sort_key ? "secondary.main" : null,
          }}
        >
          <ArrowUpwardIcon />
        </IconButton>
        </Tooltip>
        <Tooltip title={`Sort By: ${text} Descending`} arrow >
        <IconButton
          onClick={() => handleSortClick(sort_key, false)}
          sx={{
            border: 0,
            p: 0.25,
            bgcolor:
              !ascendingSort && sortedBy === sort_key ? "secondary.main" : null,
            color: !ascendingSort && sortedBy === sort_key ? "white" : null,
            borderColor: !ascendingSort && sortedBy === sort_key ? "secondary.main" : null,
          }}
        >
          <ArrowDownwardIcon />
        </IconButton>
        </Tooltip>
      </Stack>
    </TableCell>
  );
}
function SimResultsListHeader({ data, setFilteredResults, firstHeaderHeight }) {
  const { ascendingSort, setAscendingSort, sortedBy, setSortedBy, filters } =
    useSortFilter();

  function handleSortClick(field, asc) {
    setAscendingSort(asc);
    setSortedBy(field);
  }

  function countTotalTasks(claim) {
    const dayInfo = claim.day_info;
    let totalTasks = 0;

    for (const date in dayInfo) {
      if (dayInfo.hasOwnProperty(date)) {
        const taskList = dayInfo[date].task_list_for_thresholds;
        totalTasks += taskList.length; // Add the number of tasks for this date
      }
    }

    return totalTasks;
  }

  React.useEffect(() => {
    // console.log('SORTING RESULTS!')
    const sortedResults = [...data]; // Create a new array to avoid mutating the original array
    if (sortedBy === "id") {
      // HANDLE ID SORTS
      sortedResults.sort((first, second) => {
        return ascendingSort
          ? first.claim_id.localeCompare(second.claim_id)
          : second.claim_id.localeCompare(first.claim_id);
      });
    } else if (sortedBy.startsWith("validdocs")) {
      // HANDLE VALID DOC ID SORTS
      sortedResults.sort((first, second) => {
        return ascendingSort
          ? first.num_qualifying_pairs - second.num_qualifying_pairs
          : second.num_qualifying_pairs - first.num_qualifying_pairs;
      });
    } else if (sortedBy.startsWith("pairs")) {
      sortedResults.sort((first, second) => {
        return ascendingSort
          ? first.similar_comparisons_list.length - second.similar_comparisons_list.length
          : second.similar_comparisons_list.length - first.similar_comparisons_list.length;
      });
    }
    setFilteredResults(sortedResults); // Update state with the new sorted array
  }, [sortedBy, ascendingSort, filters]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TableRow
      sx={{
        width: "100%",
        top: firstHeaderHeight,
        position: "sticky",
        zIndex: 1,
      
      }}
    >
      <ColumnInfo
        text={"Claim ID"}
        borderLeft={0}
        handleSortClick={handleSortClick}
        sortedBy={sortedBy}
        ascendingSort={ascendingSort}
        sort_key={"id"}
      />
      <ColumnInfo
        text={"Qualifying Comparisons"}
        handleSortClick={handleSortClick}
        sortedBy={sortedBy}
        ascendingSort={ascendingSort}
        sort_key={"validdocs"}
      />
      <ColumnInfo
        text={"Similar Comparisons"}
        handleSortClick={handleSortClick}
        sortedBy={sortedBy}
        ascendingSort={ascendingSort}
        sort_key={"pairs"}
      />
    </TableRow>
  );
}

export default SimResultsListHeader;
